import { NavItemType } from '@app/types';
import { IconHome } from '@tabler/icons-react';
import { FaRegFolder } from 'react-icons/fa';

const menuItems: { items: NavItemType[] } = {
  items: [
    {
      id: 'home',
      type: 'group',
      children: [
        {
          id: 'default',
          title: 'Home',
          type: 'item',
          url: '/home',
          icon: IconHome,
          breadcrumbs: false,
        },
        // Directly under Home, as Martin asked (ZLAYT-1476). It used to be
        // in the bottom list, which narrow screens do not show.
        {
          id: 'all-documents',
          title: 'My Documents',
          type: 'item',
          url: '/my-documents/cases',
          icon: FaRegFolder,
          breadcrumbs: false,
        },
      ],
    },
  ],
};

export default menuItems;
